const config = {
  apiKey: 'AIzaSyALXfO0-EnVZC55pbFVWVSyYGDYfL_U1ok',
  authDomain: 'kurlon-pincodes-mapper.firebaseapp.com',
  databaseURL: 'https://kurlon-pincodes-mapper.firebaseio.com',
  projectId: 'kurlon-pincodes-mapper',
  storageBucket: 'kurlon-pincodes-mapper.appspot.com',
  messagingSenderId: '886131287528',
  appId: '1:886131287528:web:5d3d15a9f5b99f5b96705d',
};

export default config;
